export const HEADER_BANNERS_TYPES = {
  downloadExtension: 'downloadExtension',
};
